import { Component } from '@opten/compiler/metadata/component';
import { FlipbookLinkLayer } from './flipbook-links';

const SCRIPT_PATH = '/scripts/pdflipbook/';

// requires /scripts/pdflipbook/pdflipbook.js to be loaded in the layout
@Component({ className: 'js-flipbook' })
export class FlipbookComponent {
	constructor(private element: HTMLElement) {
		const url = this.element.getAttribute('data-url');
		const flipbook = (window as any).PDFlipbook;
		if (!url || !flipbook) {
			return;
		}

		// the script adds .fb-root (height: 100%) to the book element, so the book is a child filling the sized wrapper
		const book = document.createElement('div');
		book.className = 'c-flipbook__book';
		this.element.appendChild(book);

		const instance = flipbook.create(book, {
			url,
			pdfjsSrc: `${SCRIPT_PATH}pdf.min.js`,
			pdfWorkerSrc: `${SCRIPT_PATH}pdf.worker.min.js`,
		});

		new FlipbookLinkLayer(this.element, book, instance);
	}
}
